import { useMemo } from "react";
import { useAppSelector } from "../../store/hooks/hooks";
import { InputRow } from "./InputRow";
import type { IDDItem } from "../../components/common/DropdownMenu";
import { UnitConverter } from "../../components/MeasurementUnits/UnitConverter";

interface IProps {
	wellId: "well1" | "well2",
	onSelectUnit: (inputId: string, unitId: string) => void,
	onInputChange: (inputName: string, value: number | null) => void,
}

const converter = new UnitConverter();

export const HorizontalWellInputs = (props: IProps) => {
	const calculator = useAppSelector(state => state.iprCalculator);

	const unitsDDItems: { [key: string]: IDDItem[] } = useMemo(() => {
		const well = props.wellId === "well1" ? calculator.well1 : calculator.well2;

		return well.horizontalInputs.reduce<Record<string, IDDItem[]>>((acc, input) => {
			const units = converter.getUnitsByCategory(input.unitCategoryId);
			acc[input.id] = units.map(unit => ({
				id: unit.id,
				translationKey: `measurement_units.${unit.category}.${unit.id}`
			} as IDDItem));
			return acc;
		}, {});

	}, [calculator, props.wellId]);

	const inputs = useMemo(() => {
		return props.wellId === "well1" ? calculator.well1.horizontalInputs : calculator.well2.horizontalInputs;
	}, [calculator, props.wellId]);

	return <div className="ipr__horizontal-well-inputs">
		{inputs.map((input) => (
			<InputRow
				key={`${props.wellId}-horiz-${input.id}`}
				inputId={input.id}
				dropdownItems={unitsDDItems[input.id]}
				onInputChange={props.onInputChange}
				onSelectUnit={props.onSelectUnit}
			/>
		))}
	</div>;
};


